import { Link } from 'react-router-dom'
import { Image, ArrowRight } from 'lucide-react'

const Home = () => {
  const tools = [
    {
      name: '图片水印',
      description: '为图片添加文字水印，支持多种位置和透明度设置',
      icon: Image,
      href: '/watermark',
      color: 'bg-blue-500',
    },
  ]

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      {/* Hero Section */}
      <div className="text-center mb-16">
        <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
          Web工具站
        </h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
          免费提供各种实用的在线工具，简单易用，无需注册，支持移动端访问
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/watermark"
            className="btn-primary inline-flex items-center space-x-2"
          >
            <span>开始使用</span>
            <ArrowRight size={16} />
          </Link>
        </div>
      </div>

      {/* Tools Grid */}
      <div className="mb-16">
        <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
          可用工具
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {tools.map((tool) => {
            const Icon = tool.icon
            return (
              <Link
                key={tool.name}
                to={tool.href}
                className="card hover:shadow-lg transition-shadow duration-200 group"
              >
                <div className="flex items-center space-x-4 mb-4">
                  <div className={`w-12 h-12 ${tool.color} rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-200`}>
                    <Icon className="text-white" size={24} />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">
                    {tool.name}
                  </h3>
                </div>
                <p className="text-gray-600 mb-4">
                  {tool.description}
                </p>
                <div className="flex items-center text-primary-600 font-medium">
                  <span>立即使用</span>
                  <ArrowRight size={16} className="ml-1 group-hover:translate-x-1 transition-transform duration-200" />
                </div>
              </Link>
            )
          })}
        </div>
      </div>

      {/* Features Section */}
      <div className="bg-white rounded-2xl p-8 md:p-12">
        <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
          为什么选择我们
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl">🚀</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              快速便捷
            </h3>
            <p className="text-gray-600">
              无需下载安装，打开浏览器即可使用，处理速度快
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl">🔒</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              安全可靠
            </h3>
            <p className="text-gray-600">
              文件处理完全在本地进行，不会上传到服务器，保护隐私
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl">📱</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              移动友好
            </h3>
            <p className="text-gray-600">
              完美适配手机和平板设备，随时随地使用各种工具
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home